export var LOST_BUSINESS_NOTIFIER_NOTIFY_PATH = '/_serverless/wixstores-lost-business-notifier/lost-business';
export var START_FAST_FLOW_URL = '/_api/wix-ecommerce-renderer-web/store-front/checkout/cart/{cartId}/startFastFlow';
//# sourceMappingURL=constants.js.map